import { useFlags } from 'launchdarkly-react-client-sdk';

import { useIsLdIdentifiedWithFlagsForDispensary } from 'src/utils/launch-darkly/identified-dispensary';
import useCurrentDispensary from 'src/dispensary/hooks/use-current-dispensary';

export const EMBEDDED_STICKY_HEADER_ROLLOUT = 'growth.ecomm.embedded-sticky-header.rollout';

export function useEmbeddedStickyHeaderRollout(): boolean {
  const flags = useFlags();
  const { dispensary } = useCurrentDispensary();
  const isIdentified = useIsLdIdentifiedWithFlagsForDispensary(dispensary?.id);
  return isIdentified && flags[EMBEDDED_STICKY_HEADER_ROLLOUT] === true;
}
